// {{WORKTREE_ROOT}}/picosponsorconsole/app/entry.client.tsx
// PLAN2 WP10
import { RemixBrowser } from "@remix-run/react";
import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
startTransition(() => { hydrateRoot(document, <StrictMode><RemixBrowser /></StrictMode>); });
